import React from 'react';
import AutomationApp from '@atlassian/jira-automation/src/index.tsx';
import Breadcrumb from '@atlassian/jira-breadcrumbs/src/breadcrumb/component.tsx';
import Spinner from '@atlassian/jira-common-components-spinner/src/view.tsx';
import type { IntlShapeV2 as IntlShape } from '@atlassian/jira-intl/src/v2/types.tsx';
import { useNavigationAutomationLegacyEnabledResource } from '@atlassian/jira-navigation-apps-sidebar-common/src/controllers/common/navigation-automation-resource/index.tsx';
import type { ProjectContext } from '@atlassian/jira-router-resources-project-context/src/services/project-context/types.tsx';
import type { TenantContext } from '@atlassian/jira-shared-types/src/tenant-context.tsx';
import AppContainer from '@atlassian/jira-spa-apps-project-settings-common/src/components/app-container.tsx';
import messages from './messages.tsx';

export type Props = {
	tenantContext: TenantContext;
	projectContext: ProjectContext | null;
	intl: IntlShape;
};

const JiraAutomationAppWrapper = ({
	tenantContext,
	projectContext,
	intl: { formatMessage },
}: Props) => {
	const { enabled: isLegacyAutomationEnabled } =
		useNavigationAutomationLegacyEnabledResource().data || {};

	if (!projectContext || !tenantContext) {
		return <Spinner />;
	}

	const { projectId, projectKey, projectType } = projectContext;
	return (
		<AppContainer baseUrl={tenantContext.baseUrl} projectKey={projectKey} gridLayout="fluid">
			{isLegacyAutomationEnabled ? (
				<Breadcrumb
					breadcrumb={{
						text: formatMessage(messages.breadcrumb),
					}}
				>
					<AutomationApp
						container={{
							id: projectId,
							key: projectKey,
							type: projectType,
						}}
					/>
				</Breadcrumb>
			) : (
				<AutomationApp
					container={{
						id: projectId,
						key: projectKey,
						type: projectType,
					}}
				/>
			)}
		</AppContainer>
	);
};

export default JiraAutomationAppWrapper;
